import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  setOf1u3mizs95ngxo as setOf,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  get_pending3bzoyvzwzq8kn as get_pending,
  TimerAction_CompleteLineItem_getInstance3bxbacatbrybs as TimerAction_CompleteLineItem_getInstance,
  TimerAction_AllowLockProject_getInstance3xutugx5am7q as TimerAction_AllowLockProject_getInstance,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  Creditv1m3yq08fl3i as Credit,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  get_atStart2tgdnaxgj04ln as get_atStart,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  lineItemAddChangeButton2cl2byr2d3toa as lineItemAddChangeButton,
  lineItemAddCreditButtonjm3cq3yje8r4 as lineItemAddCreditButton,
} from './components.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../../screens/common/ProjectView.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../../keyValue.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../../files/renderFiles.mjs';
import { label287uhiq3m9m4z as label2 } from '../../../label2.mjs';
import { get_darkSection25mxxvxk8ts3b as get_darkSection } from '../../../../theming/sections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  lensUnread1tcpdysie4g78 as lensUnread,
} from '../../../../../sdk/UserSession.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  LineItemState_Cancelled_getInstance3kcyrqker8w6h as LineItemState_Cancelled_getInstance,
  LineItemState_Disputed_getInstance1ejlicwa0ud20 as LineItemState_Disputed_getInstance,
  LineItemState_Issue_getInstancewwqrry76cukq as LineItemState_Issue_getInstance,
  LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance,
  LineItemState_NotApproved_getInstance1n0ztla6z4oyz as LineItemState_NotApproved_getInstance,
  LineItemState_InProgress_getInstance30c0b4tuqukui as LineItemState_InProgress_getInstance,
  LineItemState_RequestingReview_getInstance2ojeopd3nid3v as LineItemState_RequestingReview_getInstance,
  LineItemState_ForceComplete_getInstance30t7ooav0u0dj as LineItemState_ForceComplete_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
  LineItemState_OnHold_getInstance5v65qotr6ndv as LineItemState_OnHold_getInstance,
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
  ProjectState_PreSubstantialCompletion_getInstancep7r5dsq5lipe as ProjectState_PreSubstantialCompletion_getInstance,
  LineItemState_WorkingOnRemedy_getInstanceklan96hlrfx7 as LineItemState_WorkingOnRemedy_getInstance,
  ProjectState_PendingStart_getInstance2dqkzmcm0blyg as ProjectState_PendingStart_getInstance,
  ProjectState_Locked_getInstance2lzy284wfpx83 as ProjectState_Locked_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  get_isSignOff22izp8i5fus79 as get_isSignOff,
  Appealdu3t1bemwr4j as Appeal,
  RemedyComplete1j0nrocri3mi3 as RemedyComplete,
  Credit2hxrirfggfkql as Credit_0,
  ForceCompletemak8s8g9i3mp as ForceComplete,
  ClientResolution1kcdgkwzeikik as ClientResolution,
  RequestComplete2fbpvksxlxjbf as RequestComplete,
  Remedy1wqpxp6byw9t6 as Remedy,
  RequestSiteVisit1o0qmklsbtvus as RequestSiteVisit,
  Handled3ngpo7bepl0ux as Handled,
  MoreInfof0qn3z2grweu as MoreInfo,
  NeedsApproval1ftfboe6wlgyi as NeedsApproval,
  Accept733y3zepx42g as Accept,
} from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  banners2ndq1wx79ibxx as banners,
  renderBanners1vh1dpq8pq90j as renderBanners,
} from '../../../../../utils/Banner.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { renderPunchListRow3mo466g522loq as renderPunchListRow } from '../punchList/renderPunchlists.mjs';
import { leftExpandButtonWithUnread1gpbgdpec45fr as leftExpandButtonWithUnread } from '../../../expansion.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  SecondaryButtonSemantic_getInstance1ksz6yxlolvnl as SecondaryButtonSemantic_getInstance,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  newNotesAllowed1s45uieazjo3d as newNotesAllowed,
  isComplete3isyniin1qz2u as isComplete,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { renderContractorNotes38zg0r7j0ume5 as renderContractorNotes } from '../../renderContractorNotes.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { ForegroundSemantic2og103ajpnjfv as ForegroundSemantic } from '../../../../theming/colorManagement.mjs';
import {
  ChangeStatus_Accepted_getInstance2k8febn59t1nq as ChangeStatus_Accepted_getInstance,
  get_status1d77371nrw24k as get_status,
} from '../changeOrders/data.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  isUnread2u0ehyt0ioouz as isUnread,
  isUnread2wfj6ps7oiv9h as isUnread_0,
} from '../../../../../extensions/HasReadBy.ext.mjs';
import {
  unreadIconWhen1430ixd91bo9h as unreadIconWhen,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../iconShortcuts.mjs';
import { renderPriceChangegxsbuhvani39 as renderPriceChange } from '../../../priceChanges.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../../theming/states.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../../../utils/tables/ColumnWeights.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  awaitSuspendingfmims6z9kmaq as awaitSuspending,
} from '../../../../../utils/utils.mjs';
import {
  applyReactiveActionFormatting11beyf0tv05i4 as applyReactiveActionFormatting,
  Companion_instance1hgjusdx1kcma as Companion_instance_0,
  ButtonActionqmmxsu493eh2 as ButtonAction,
} from '../../../../../utils/ButtonAction.mjs';
import { get_increasedProjectPricecnanfo88a7j2 as get_increasedProjectPrice } from '../../../../../utils/AdjustedLineItem.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  acceptActionName1soryjzupmune as acceptActionName,
  acceptConfirmationText15yt66nimg6we as acceptConfirmationText,
} from '../../../../../extensions/CompletionResponse.ext.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { requiresAction13nb01xm2r5gu as requiresAction } from '../../../../../extensions/FlowPermissions.ext.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_1 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  ItemChangee3c665suy3yz as ItemChange,
  LineItem2rt64afaiyloc as LineItem,
  Incident3aojs8cp7629c as Incident,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  navigateOrDialog1m0cnx3luzasq as navigateOrDialog,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../../nav/crowpay.mjs';
import { CreateOrEditNote2axvnom01lmg9 as CreateOrEditNote } from '../../../../dialogs/CreateOrEditNote.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance_1 } from './LineItemCompletionForm.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_2 } from '../../activity/concerns/IncidentReportForm.mjs';
import { CreditDetails2g0vi8qhuk0sb as CreditDetails } from '../../../../dialogs/BasicFlowForms.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_started14uxkm9fjiknx as get_started } from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_3 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../../dialogs/GenericConfirmationDialog.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { serializable2l0a6bc0gtxdw as serializable } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/serialization.mjs';
import { WorkItemRequestSignOffDialog3jlywf6lxbyl7 as WorkItemRequestSignOffDialog } from '../../../../dialogs/RequestSignOffDialog.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../../../dialogs/GenericDialog.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_changeLogRowHeight() {
  _init_properties_lineItemDetails_kt__1mr0y1();
  return changeLogRowHeight;
}
var changeLogRowHeight;
function renderLineItemDetails(_this__u8e3s4, item, logs, punchLists, lineItemCompletionMessages, expanded, writer) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  // Inline function 'kotlin.with' call
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp = get_unpadded(writer);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  var tmp_0;
  var tmp_1 = null;
  if (!((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null)) {
    tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_0 = Companion_getInstance();
  }
  var tmp_2 = view.ibb(tmp_0, indented(view, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var pendingPayApp = remember(VOID, VOID, VOID, ($this$remember) => {
    var line = $this$remember.baj(item).kf9_1;
    var tmp0 = $this$remember.baj(_this__u8e3s4.hgt());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.s6v_1.equals(line) && element.b6w_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  });
  var pendingChange = remember(VOID, VOID, VOID, ($this$remember) => {
    var line = $this$remember.baj(item).kf9_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.igt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.f72_1.equals(line)) {
        destination.v(element);
      }
    }
    var changes = destination;
    var tmp;
    if (changes.i1()) {
      return false;
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = HashSet().ha();
    var _iterator__ex2g4s_0 = changes.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item_0 = _iterator__ex2g4s_0.o1();
      var tmp$ret$5 = item_0.e72_1;
      destination_0.v(tmp$ret$5);
    }
    var ids = destination_0;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = $this$remember.baj(_this__u8e3s4.vgv());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      if (ids.t1(element_0.q57_1)) {
        destination_1.v(element_0);
      }
    }
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_2 = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s_2 = destination_1.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var element_1 = _iterator__ex2g4s_2.o1();
      var tmp$ret$10 = element_1.q57_1;
      destination_2.s3(tmp$ret$10, element_1);
    }
    var requests = destination_2;
    var tmp$ret$15;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(changes, Collection())) {
        tmp_0 = changes.i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$15 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_3 = changes.m1();
      while (_iterator__ex2g4s_3.n1()) {
        var element_2 = _iterator__ex2g4s_3.o1();
        var tmp_1;
        if (get_pending(element_2)) {
          var tmp0_safe_receiver = requests.p3(element_2.e72_1);
          tmp_1 = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v57_1) == null);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$15 = true;
          break $l$block_2;
        }
      }
      tmp$ret$15 = false;
    }
    return tmp$ret$15;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc(), 0.1);
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(true);
  view_2.zb8(get_AppDimensions().xg1_1);
  lineItemBanners(_this__u8e3s4, view_2, item, _this__u8e3s4.jfy(), lineItemCompletionMessages, pendingPayApp, pendingChange, _this__u8e3s4.rgj());
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp_3 = get_atTopEnd(view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_3.xbm(false);
    var item_0 = lens(item, renderLineItemDetails$lambda);
    lineItemAddChangeButton(_this__u8e3s4, view_3, item_0);
    lineItemAddCreditButton(view_3, item_0, _this__u8e3s4.jfy());
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_3, view_3);
  }
  var tmp_4 = shownWhen(view_2, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this$shownWhen.baj(item).nf9_1;
    return charSequenceLength(this_0) > 0;
  });
  view_2.jbb(tmp_4, keyString(view_2, 'Description', ($this$keyString) => $this$keyString.baj(item).nf9_1));
  view_2.bbn(get_rem(0.5));
  var files = lens(item, renderLineItemDetails$lambda_0);
  var tmp_5 = shownWhen(view_2, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(files).i1();
  });
  view_2.jbb(tmp_5, label2(view_2, 'Files (Images, Bids, Plans, Specs)', VOID, ($this$label2) => renderFiles($this$label2, files, get_AppDimensions().rg2_1)));
  view_0.fbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view_0.pc(), 0.5);
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_0.fbb(p_4, view_4);
  workItemTasks(view_0, item, punchLists, _this__u8e3s4.jfy(), _this__u8e3s4.rgj());
  workItemNotes(view_0, item, expanded, logs, _this__u8e3s4.rgj());
  workItemChangeLog(_this__u8e3s4, item, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Space())(view_0.pc(), 0.5);
  var tmp0_elvis_lhs_5 = view_0.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
  view_0.ebb(p_5, view_5);
  view_0.fbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_6 = view_0.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
  view_0.ebb(p_6, view_6);
  view_6.xbm(true);
  view_6.jbb(view_6.ibb(sizeConstraints(view_6, VOID, VOID, get_AppDimensions().ug2_1), get_darkSection(view_6)), workItemActionBar(view_6, item, punchLists, _this__u8e3s4.jfy(), lineItemCompletionMessages, pendingPayApp, pendingChange, _this__u8e3s4.pgj_1, _this__u8e3s4.sh2(), _this__u8e3s4.rgj()));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Space())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_6.fbb(p_7, view_7);
  view_0.fbb(p_6, view_6);
  view.fbb(p_0, view_0);
  view.jbb(tmp_2, view_0);
  writer.fbb(p, view);
  return writer.jbb(tmp, view);
}
function lineItemBanners(data, _this__u8e3s4, item, project, messages, pendingPayApp, pendingChange, lens_0, scope) {
  scope = scope === VOID ? null : scope;
  _init_properties_lineItemDetails_kt__1mr0y1();
  var unit = scope == null ? 'item' : 'scope';
  var timers = remember(VOID, VOID, VOID, ($this$remember) => {
    var item_0 = $this$remember.baj(item);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(data.ngf());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (equals(element.t7t_1, item_0.kf9_1)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var autoReleaseTimer = remember(VOID, VOID, VOID, ($this$remember) => lineItemBanners$findAction($this$remember.baj(timers), TimerAction_CompleteLineItem_getInstance()));
  var lockProjectTimer = remember(VOID, VOID, VOID, ($this$remember) => lineItemBanners$findAction($this$remember.baj(timers), TimerAction_AllowLockProject_getInstance()));
  var locked = lens(project, lineItemBanners$lambda);
  var banners_0 = remember(VOID, VOID, VOID, ($this$remember) => {
    var item_0 = $this$remember.baj(item);
    var project_0 = $this$remember.baj(project);
    var state = item_0.kfy();
    var pendingPayApp_0 = $this$remember.baj(pendingPayApp);
    var pendingChange_0 = $this$remember.baj(pendingChange);
    var messages_0 = $this$remember.baj(messages);
    var autoRelease = $this$remember.baj(autoReleaseTimer);
    var tmp = lens_0.xgj();
    var tmp0_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var permissions = new (CompletionFlowPermissions())(item_0.hf9_1, tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1, messages_0, null);
    var tmp_0;
    if (!(scope == null) && !$this$remember.baj(scope).e99() || (scope == null && !(item_0.e99() == null))) {
      return emptyList();
    }
    return banners(($this$banners) => {
      var tmp;
      if ($this$remember.baj(locked)) {
        $this$banners.xfz('WI-ProjectLocked', 'Project locked. Funds held in escrow pending resolution.');
        return Unit_instance;
      }
      var tmp_0;
      if (state.equals(LineItemState_Cancelled_getInstance())) {
        $this$banners.xfz('WI-Canceled', 'This ' + unit + ' has been cancelled, you can view its information but it cannot be changed.');
        return Unit_instance;
      }
      var tmp0 = messages_0;
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.collections.lastOrNull' call
        var iterator = tmp0.u1(tmp0.p1());
        while (iterator.v6()) {
          var element = iterator.x6();
          if (get_isSignOff(element.f8w())) {
            tmp$ret$4 = element;
            break $l$block;
          }
        }
        tmp$ret$4 = null;
      }
      var tmp0_safe_receiver = tmp$ret$4;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g6h_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : format(tmp1_safe_receiver, Formats_getInstance().k8z_1);
      var lastSignOffRequestSentAt = tmp2_elvis_lhs == null ? '...' : tmp2_elvis_lhs;
      var tmp3_safe_receiver = autoRelease;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x7t_1;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : format(tmp4_safe_receiver, Formats_getInstance().k8z_1);
      var autoReleasesAt = tmp5_elvis_lhs == null ? '...' : tmp5_elvis_lhs;
      var tmp_1;
      if (item_0.hf9_1.v6k_1) {
        tmp_1 = 'Project lock is available. Either party can lock the project.';
      } else {
        var tmp6_safe_receiver = $this$remember.baj(lockProjectTimer);
        var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.x7t_1;
        var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : format(tmp7_safe_receiver, Formats_getInstance().k8z_1);
        tmp_1 = 'Lock available on ' + (tmp8_elvis_lhs == null ? '...' : tmp8_elvis_lhs) + '.';
      }
      var lockAvailableMsg = tmp_1;
      var previousMessage = lastOrNull(messages_0);
      var autoReleaseWarning = 'WI-AutoRelease-warn';
      var lockAvailableWarning = 'WI-LockProject-warn';
      var tmp_2;
      if (lens_0.xgj()) {
        var tmp_3;
        if (state.equals(LineItemState_InProgress_getInstance())) {
          $this$banners.xfz('H-WI-InProgress-info', 'Good communication ensures great results. Stay engaged with your contractor to clarify the work and ensure it aligns with your expectations. Asking questions now can prevent misunderstandings and keep the project on track.');
          tmp_3 = Unit_instance;
        } else {
          if (state.equals(LineItemState_KeepWorking_getInstance())) {
            $this$banners.xfz('H-WI-KeepWorking-info', 'Contractor is completing additional work and will request sign-off again when ready.');
            $this$banners.yfz('H-WI-KeepWorking-warn', 'The funds release timer has been cleared. A new timer will start when the contractor requests sign-off again.');
            tmp_3 = Unit_instance;
          } else {
            var tmp_4 = previousMessage == null ? null : previousMessage.f8w();
            if (tmp_4 instanceof RequestComplete()) {
              $this$banners.xfz('H-WI-RequestingReview-info', 'Work look good? "Approve Work" now to release funds. Or click "Review Request" to see details and choose your response.');
              $this$banners.yfz('H-WI-RequestingReview-warn', 'Contractor requested sign-off on ' + lastSignOffRequestSentAt + '. Respond within 14 days or funds release on ' + autoReleasesAt + '.');
              tmp_3 = Unit_instance;
            } else {
              var tmp_5 = previousMessage == null ? null : previousMessage.f8w();
              if (tmp_5 instanceof MoreInfo()) {
                $this$banners.xfz('H-WI-MoreInfo-info', 'Contractor needs more information to respond. Click "Review Request" to provide details.');
                $this$banners.yfz(autoReleaseWarning, 'If no response is given funds will release on ' + autoReleasesAt + '.');
                tmp_3 = Unit_instance;
              } else {
                var tmp_6 = previousMessage == null ? null : previousMessage.f8w();
                if (tmp_6 instanceof Handled()) {
                  $this$banners.xfz('H-WI-Handled-info', 'Contractor says concerns are handled. Click "Review Request" to accept or respond.');
                  $this$banners.yfz(autoReleaseWarning, 'If no response is given funds will release on ' + autoReleasesAt + '.');
                  tmp_3 = Unit_instance;
                } else {
                  var tmp_7;
                  var tmp_8 = previousMessage == null ? null : previousMessage.f8w();
                  if (tmp_8 instanceof ForceComplete()) {
                    tmp_7 = true;
                  } else {
                    tmp_7 = state.equals(LineItemState_ForceComplete_getInstance());
                  }
                  if (tmp_7) {
                    var escalate = permissions.u8w() ? 'file a dispute' : 'raise an issue';
                    $this$banners.xfz('H-WI-ForceComplete-info', 'Contractor marked this complete. Click "Review Request" to accept or ' + escalate + '.');
                    $this$banners.yfz(autoReleaseWarning, 'If no response is given funds will auto-release on ' + autoReleasesAt + '.');
                    tmp_3 = Unit_instance;
                  } else {
                    var tmp_9 = previousMessage == null ? null : previousMessage.f8w();
                    if (tmp_9 instanceof RequestSiteVisit()) {
                      $this$banners.xfz('H-WI-RequestJobVisit-info', 'Contractor requested a site visit. Click "Review Request" to confirm.');
                      var tmp_10;
                      if (permissions.v8w()) {
                        $this$banners.yfz(lockAvailableWarning, lockAvailableMsg);
                        tmp_10 = Unit_instance;
                      } else {
                        $this$banners.yfz(autoReleaseWarning, 'If no response is given funds will auto-release on ' + autoReleasesAt + '.');
                        tmp_10 = Unit_instance;
                      }
                      tmp_3 = tmp_10;
                    } else {
                      var tmp_11;
                      var tmp_12;
                      if (!permissions.c8y()) {
                        var tmp0_0 = messages_0;
                        var tmp$ret$5;
                        $l$block_1: {
                          // Inline function 'kotlin.collections.any' call
                          var tmp_13;
                          if (isInterface(tmp0_0, Collection())) {
                            tmp_13 = tmp0_0.i1();
                          } else {
                            tmp_13 = false;
                          }
                          if (tmp_13) {
                            tmp$ret$5 = false;
                            break $l$block_1;
                          }
                          var _iterator__ex2g4s = tmp0_0.m1();
                          while (_iterator__ex2g4s.n1()) {
                            var element_0 = _iterator__ex2g4s.o1();
                            if (element_0.c6h_1) {
                              tmp$ret$5 = true;
                              break $l$block_1;
                            }
                          }
                          tmp$ret$5 = false;
                        }
                        tmp_12 = tmp$ret$5;
                      } else {
                        tmp_12 = false;
                      }
                      if (tmp_12) {
                        tmp_11 = !permissions.u8w();
                      } else {
                        tmp_11 = false;
                      }
                      if (tmp_11) {
                        $this$banners.xfz('H-WI-ConcernRaised-info', permissions.f8y() ? 'Contractor has not responded for 5 days. Click "View Concern" for options.' : "You've sent your concerns to the contractor. If contractor doesn't respond within 5 days, you can Raise Issue.");
                        $this$banners.yfz('H-WI-ConcernRaised-warn', 'Funds release timer is paused while waiting for contractor response.');
                        tmp_3 = Unit_instance;
                      } else {
                        if (!permissions.c8y() && state.equals(LineItemState_Issue_getInstance())) {
                          var noResponseText = permissions.i8y() ? 'Contractor has not responded for 5 days. Click "View Concern" for options.' : "If no response within 5 days, you'll have the option to escalate.";
                          $this$banners.xfz('H-WI-IssueRaised-info', "You've raised an Issue. Contractor will respond with options to address your concerns. " + noResponseText + ' Click "View Concern" to see details.');
                          $this$banners.yfz('H-WI-IssueRaised-warn', 'Funds release timer is paused while waiting for contractor response.');
                          tmp_3 = Unit_instance;
                        } else {
                          if (!permissions.c8y() && state.equals(LineItemState_Disputed_getInstance())) {
                            $this$banners.xfz('H-WI-DisputeFiled-info', 'You\'ve filed a Dispute. Contractor will respond with options to address your concerns. Click "View Concern" to see details.');
                            $this$banners.yfz('H-WI-DisputeFiled-warn', 'Funds release timer has been put on hold. If no solution is reached after 14 days either party can lock the project.');
                            tmp_3 = Unit_instance;
                          } else {
                            var tmp_14 = previousMessage == null ? null : previousMessage.f8w();
                            if (tmp_14 instanceof Credit_0()) {
                              $this$banners.xfz('H-WI-Credit-info', 'Contractor proposed a credit to settle. Click "Review Concern" to see details and respond.');
                              $this$banners.yfz(lockAvailableWarning, lockAvailableMsg);
                              tmp_3 = Unit_instance;
                            } else {
                              var tmp_15 = previousMessage == null ? null : previousMessage.f8w();
                              if (tmp_15 instanceof Remedy()) {
                                $this$banners.xfz('H-WI-RemedyPlan-info', 'Contractor proposed a remedy plan. Click "Review Concern" to see details and respond.');
                                $this$banners.yfz('H-WI-RemedyPlan-warn', lockAvailableMsg + ' If accepted, lock will be unavailable during plan implementation.');
                                tmp_3 = Unit_instance;
                              } else {
                                var tmp_16 = previousMessage == null ? null : previousMessage.f8w();
                                if (tmp_16 instanceof Appeal()) {
                                  $this$banners.xfz('H-WI-Appeal-info', 'Contractor appealed the dispute. Click "Review Concern" to see their position and respond.');
                                  $this$banners.yfz(lockAvailableWarning, lockAvailableMsg);
                                  tmp_3 = Unit_instance;
                                } else {
                                  var tmp_17 = previousMessage == null ? null : previousMessage.f8w();
                                  if (tmp_17 instanceof ClientResolution()) {
                                    $this$banners.xfz('H-WI-ClientResolution-info', 'You proposed an alternative settlement. Click "View Concern" to see your message while waiting for contractor response.');
                                    $this$banners.yfz(lockAvailableWarning, lockAvailableMsg);
                                    tmp_3 = Unit_instance;
                                  } else {
                                    var tmp_18;
                                    var tmp_19;
                                    if (state.d4(LineItemState_KeepWorking_getInstance()) >= 0) {
                                      // Inline function 'kotlin.collections.isNotEmpty' call
                                      tmp_19 = !messages_0.i1();
                                    } else {
                                      tmp_19 = false;
                                    }
                                    if (tmp_19) {
                                      tmp_18 = item_0.mfy() == null;
                                    } else {
                                      tmp_18 = false;
                                    }
                                    if (tmp_18) {
                                      $this$banners.xfz('H-WI-ViewConcernReminder', permissions.c8y() ? 'Click "Review Concern" button to comment on, review, or respond to concerns.' : 'Click "View Concern" button to comment on, review, or respond to concerns.');
                                      tmp_3 = Unit_instance;
                                    } else {
                                      if (!(item_0.mfy() == null)) {
                                        var cmp = permissions.s8y();
                                        var tmp_20;
                                        if (cmp instanceof Credit_0()) {
                                          $this$banners.xfz('H-WI-Complete-Credit', "Dispute settled. You accepted contractor's " + MonetaryValue__toString_impl_xslc77(cmp.r8z_1) + ' credit. Adjusted funds released for collection.');
                                          tmp_20 = Unit_instance;
                                        } else {
                                          if (cmp instanceof RemedyComplete()) {
                                            var credit = cmp.y8y_1.i8z_1;
                                            var tmp_21;
                                            var tmp_22 = credit;
                                            if (!((tmp_22 == null ? null : new (MonetaryValue())(tmp_22)) == null)) {
                                              $this$banners.xfz('H-WI-Complete-RemedyPlan-Credit', "Dispute settled. You accepted contractor's completed remedy plan and " + MonetaryValue__toString_impl_xslc77(credit) + ' credit. Adjusted funds released for collection.');
                                              tmp_21 = Unit_instance;
                                            } else {
                                              $this$banners.xfz('H-WI-Complete-RemedyPlan', "Dispute settled. You accepted contractor's completed remedy plan. Full funds released for collection.");
                                              tmp_21 = Unit_instance;
                                            }
                                            tmp_20 = tmp_21;
                                          } else {
                                            if (cmp instanceof Appeal()) {
                                              $this$banners.xfz('H-WI-Complete-Appeal', "Dispute settled. You accepted contractor's appeal. Full funds released for collection.");
                                              tmp_20 = Unit_instance;
                                            } else {
                                              var tmp18_safe_receiver = scope;
                                              var tmp19_safe_receiver = tmp18_safe_receiver == null ? null : $this$remember.baj(tmp18_safe_receiver);
                                              var tmp20_elvis_lhs = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.d99();
                                              $this$banners.xfz('H-WI-Complete-info', trimIndent('\n                            Great news! ' + (tmp20_elvis_lhs == null ? item_0.lf9_1 : tmp20_elvis_lhs) + ' has been completed and approved.\n                            \n                            Your contractor will continue working on the project. Keep tracking updates in Stoze, and remember to review and approve upcoming work items as sign-off is requested. Maintain open communication with your contractor to ensure a smooth process and avoid potential delays.\n                        '));
                                              tmp_20 = Unit_instance;
                                            }
                                          }
                                        }
                                        tmp_3 = tmp_20;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        tmp_2 = tmp_3;
      } else {
        var tmp_23;
        if (item_0.kfy().d4(LineItemState_RequestingReview_getInstance()) < 0 && !project_0.r97() && MonetaryValue__compareTo_impl_w7ul1r(item_0.hf9_1.o91(), $this$remember.baj(data.sh2()).a5s_1) > 0) {
          $this$banners.yfz('C-WI-Underfunded', !(item_0.lfy() == null) ? 'The client has not deposited full funds for the project. You can request sign-off once the client has deposited enough funds into escrow to fund this work item.' : 'The client has not deposited full funds for the project. You may want to contact the client to deposit remaining funds before starting work. You will not be able to request sign-off until remaining funds are deposited.');
          tmp_23 = Unit_instance;
        } else {
          if (pendingPayApp_0 || pendingChange_0) {
            if (pendingPayApp_0) {
              $this$banners.yfz('C-WI-PendingPayApp', 'This ' + unit + ' is included in a pending draw. You can request sign-off once the draw is approved, rejected, or voided.');
            }
            var tmp_24;
            if (pendingChange_0) {
              $this$banners.yfz('C-WI-PendingChange', 'This ' + unit + ' is included in a pending change. You can request sign-off once the change is approved, rejected, or voided.');
              tmp_24 = Unit_instance;
            }
            tmp_23 = tmp_24;
          } else {
            if (state.equals(LineItemState_InProgress_getInstance())) {
              $this$banners.xfz('C-WI-InProgress-info', 'Refer to original scope and change logs here for history of this ' + unit + '. Add notes and tasks for this work as desired.');
              $this$banners.yfz('C-WI-InProgress-warn', "Don't request sign off before the " + unit + ' is completed. Doing so can build mistrust in your clients.');
              tmp_23 = Unit_instance;
            } else {
              var tmp_25 = previousMessage == null ? null : previousMessage.f8w();
              if (tmp_25 instanceof RequestComplete()) {
                $this$banners.xfz('C-WI-RequestingReview-info', 'Sign-off request sent. Client will review and approve or respond with concerns.');
                $this$banners.yfz('C-WI-RequestingReview-warn', 'Request sent on ' + lastSignOffRequestSentAt + '. Awaiting client response. Auto-approval on ' + autoReleasesAt + ' if no response.');
                tmp_23 = Unit_instance;
              } else {
                if (state.equals(LineItemState_NotApproved_getInstance())) {
                  $this$banners.xfz('C-WI-NotApproved-info', item_0.pfy() ? 'It\'s been 5 days. Client can now escalate and raise an issue. Click "Review Concern" to respond.' : 'Client has concerns about this work. Click "Review Concern" to review and respond. Respond within 5 days or client can escalate and raise an issue.');
                  $this$banners.yfz('C-WI-NotApproved-warn', 'The funds release timer is paused while waiting for your response.');
                  tmp_23 = Unit_instance;
                } else {
                  if (state.equals(LineItemState_KeepWorking_getInstance())) {
                    $this$banners.xfz('C-WI-KeepWorking-info', 'You acknowledged this work needs additional completion. Request sign-off again when ready.');
                    $this$banners.yfz('C-WI-KeepWorking-warn', 'The funds release timer has been cleared. A new timer will start when you request sign-off.');
                    tmp_23 = Unit_instance;
                  } else {
                    var tmp_26 = previousMessage == null ? null : previousMessage.f8w();
                    if (tmp_26 instanceof ClientResolution()) {
                      $this$banners.xfz('C-WI-ClientResolution-info', 'Client proposed an alternative settlement. Click "Review Concern" to see details and respond.');
                      $this$banners.yfz(lockAvailableWarning, 'Funds are on hold. Review their message and respond. ' + lockAvailableMsg);
                      tmp_23 = Unit_instance;
                    } else {
                      var tmp_27 = previousMessage == null ? null : previousMessage.f8w();
                      if (tmp_27 instanceof ForceComplete()) {
                        $this$banners.xfz('C-WI-ForceComplete-info', 'You stated that work is complete. Client can accept or escalate.');
                        $this$banners.yfz('C-WI-ForceComplete-warn', 'Awaiting client response. Auto-approval on ' + autoReleasesAt + ' if no response.');
                        tmp_23 = Unit_instance;
                      } else {
                        if (permissions.c8y() && state.equals(LineItemState_Issue_getInstance())) {
                          $this$banners.xfz('C-WI-Issue-info', item_0.qfy() ? 'It\'s been 5 days. Client can now escalate and File Dispute. Click "Review Concern" to respond.' : 'Client has raised a formal Issue. Respond within 5 days or client can escalate. Click "Review Concern" to see details and respond.');
                          $this$banners.yfz('C-WI-Issue-warn', 'Funds release timer is paused while waiting for your response.');
                          tmp_23 = Unit_instance;
                        } else {
                          if (state.equals(LineItemState_Disputed_getInstance())) {
                            if (permissions.c8y()) {
                              $this$banners.xfz('C-WI-Disputed-info', 'Client has filed a formal Dispute. Click "Review Concern" to see details and propose a settlement.');
                            }
                            $this$banners.zfz('C-WI-Disputed-dang', 'Funds are on hold. Settle the dispute through available options, or after 14 days either party can lock the project.');
                            tmp_23 = Unit_instance;
                          } else {
                            if (!(item_0.mfy() == null)) {
                              var cmp_0 = permissions.s8y();
                              var tmp_28;
                              if (cmp_0 instanceof Credit_0()) {
                                $this$banners.xfz('C-WI-Complete-Credit-info', 'Dispute settled. Client accepted your credit proposal. Funds will release for collection less the credit amount.');
                                var beforeCredit = MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(item_0.v91(), cmp_0.r8z_1));
                                var credit_0 = MonetaryValue__toString_impl_xslc77(cmp_0.r8z_1);
                                var net = MonetaryValue__toString_impl_xslc77(item_0.v91());
                                $this$banners.yfz('C-WI-Complete-Credit-warn', 'Funds release within 3 business days: ' + beforeCredit + ' minus ' + credit_0 + ' = ' + net + ' available for collection.');
                                tmp_28 = Unit_instance;
                              } else {
                                if (cmp_0 instanceof RemedyComplete()) {
                                  var tmp_29;
                                  var tmp_30 = cmp_0.y8y_1.i8z_1;
                                  if (!((tmp_30 == null ? null : new (MonetaryValue())(tmp_30)) == null)) {
                                    $this$banners.xfz('C-WI-Complete-RemedyPlan-Credit-info', 'Dispute settled. Client accepted your completed remedy plan. Funds will release for collection less the credit amount.');
                                    var tmp_31 = item_0.v91();
                                    var tmp24_elvis_lhs = cmp_0.y8y_1.i8z_1;
                                    var tmp_32;
                                    var tmp_33 = tmp24_elvis_lhs;
                                    if ((tmp_33 == null ? null : new (MonetaryValue())(tmp_33)) == null) {
                                      tmp_32 = Companion_instance.o62(0);
                                    } else {
                                      tmp_32 = tmp24_elvis_lhs;
                                    }
                                    var beforeCredit_0 = MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(tmp_31, tmp_32));
                                    var tmp25_elvis_lhs = cmp_0.y8y_1.i8z_1;
                                    var tmp_34;
                                    var tmp_35 = tmp25_elvis_lhs;
                                    if ((tmp_35 == null ? null : new (MonetaryValue())(tmp_35)) == null) {
                                      tmp_34 = Companion_instance.o62(0);
                                    } else {
                                      tmp_34 = tmp25_elvis_lhs;
                                    }
                                    var credit_1 = MonetaryValue__toString_impl_xslc77(tmp_34);
                                    var net_0 = MonetaryValue__toString_impl_xslc77(item_0.v91());
                                    $this$banners.yfz('C-WI-Complete-RemedyPlan-Credit-warn', 'Funds release within 3 business days: ' + beforeCredit_0 + ' minus ' + credit_1 + ' = ' + net_0 + ' available for collection.');
                                    tmp_29 = Unit_instance;
                                  } else {
                                    $this$banners.xfz('C-WI-Complete-RemedyPlan-info', 'Dispute settled. Client accepted your completed remedy plan. Funds will release for collection.');
                                    $this$banners.yfz('C-WI-Complete-RemedyPlan-warn', 'Funds release within 3 business days. Full amount available for collection.');
                                    tmp_29 = Unit_instance;
                                  }
                                  tmp_28 = tmp_29;
                                } else {
                                  if (cmp_0 instanceof Appeal()) {
                                    $this$banners.xfz('C-WI-Complete-Appeal-info', 'Dispute settled. Client accepted your appeal. Funds will release for collection.');
                                    $this$banners.yfz('C-WI-Complete-Appeal-warn', 'Funds release within 3 business days. Full amount available for collection.');
                                    tmp_28 = Unit_instance;
                                  } else {
                                    var tmp26_safe_receiver = scope;
                                    var tmp27_safe_receiver = tmp26_safe_receiver == null ? null : $this$remember.baj(tmp26_safe_receiver);
                                    var tmp28_elvis_lhs = tmp27_safe_receiver == null ? null : tmp27_safe_receiver.d99();
                                    $this$banners.xfz('C-WI-Complete-info', trimIndent('\n                            Congratulations! ' + (tmp28_elvis_lhs == null ? $this$remember.baj(item).lf9_1 : tmp28_elvis_lhs) + ' has been completed and approved.\n                            \n                            If any loose items remain, add them to the Project Punch List to keep everything organized for final closeout. Maintain clear communication with the client to ensure alignment, manage expectations, and keep the project on track. Proactive updates build trust and help avoid unnecessary delays.\n                        '));
                                    tmp_28 = Unit_instance;
                                  }
                                }
                              }
                              tmp_23 = tmp_28;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        tmp_2 = tmp_23;
      }
      return Unit_instance;
    });
  });
  return renderBanners(_this__u8e3s4, banners_0);
}
function workItemTasks(_this__u8e3s4, item, punchLists, project, lens) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  var tmp0_title = _Constant___init__impl__v45mub('Tasks');
  renderPunchListRow(_this__u8e3s4, new (Constant())(tmp0_title), VOID, project, punchLists, item, VOID, lens, VOID, VOID, true);
  return Unit_instance;
}
function workItemNotes(_this__u8e3s4, item, itemExpanded, notes, lens) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  var logsExpanded = Signal().fak(false);
  var tmp = get_rawSession();
  var unread = lensUnread(tmp, (session) => session.zfv_1.hft(VOID, ($this$handleDelayUpdate, it) => $this$handleDelayUpdate.baj(notes)));
  leftExpandButtonWithUnread(view, logsExpanded, unread, VOID, VOID, workItemNotes$lambda);
  var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(logsExpanded));
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_1 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_2;
  var tmp_3 = null;
  if (!((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null)) {
    tmp_2 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_2 = Companion_getInstance();
  }
  var tmp_4 = view_0.ibb(tmp_2, indented(view_0, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.zb8(get_rem_0(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_1.fbb(p_2, view_2);
  if (lens.equals(ProjectLens_Contractor_getInstance())) {
    var tmp_5 = view_1.ibb(get_atStart(view_1), get_tertiaryButton(view_1));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.ebb(p_3, view_3);
    var tmp_6 = KMutableProperty0();
    var tmp_7 = Button$_get_shown_$ref_hkylj1(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_6, tmp_7, Button$_set_shown_$ref_bpvuvj(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp$ret$3 = !$this$reactiveScope.baj(item).of9_1;
      this_0.set(tmp$ret$3);
      return Unit_instance;
    });
    var tmp_8 = KMutableProperty0();
    var tmp_9 = Button$_get_enabled_$ref_61t7nx(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp$ret$5 = newNotesAllowed($this$reactiveScope.baj(item).kfy());
      this_1.set(tmp$ret$5);
      return Unit_instance;
    });
    view_3.dba(get_rem(0.3));
    specCenteredText(view_3, '+ Work Note');
    onClick(view_3, VOID, VOID, workItemNotes$slambda_0(item));
    view_1.fbb(p_3, view_3);
    view_1.jbb(tmp_5, view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Space())(view_1.pc());
    var tmp0_elvis_lhs_4 = view_1.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
    view_1.ebb(p_4, view_4);
    view_1.fbb(p_4, view_4);
  }
  var tmp_10 = ($this$renderContractorNotes) => $this$renderContractorNotes.baj(item).lf9_1;
  renderContractorNotes(view_1, notes, tmp_10, lens, () => {
    itemExpanded.mam(true);
    logsExpanded.mam(true);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Space())(view_1.pc());
  var tmp0_elvis_lhs_5 = view_1.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
  view_1.ebb(p_5, view_5);
  view_1.fbb(p_5, view_5);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_4, view_1);
  view.fbb(p_0, view_0);
  var tmp$ret$25 = view.jbb(tmp_1, view_0);
  view.jbb(tmp_0, tmp$ret$25);
  greySeparator(view);
  _this__u8e3s4.fbb(p, view);
}
function workItemChangeLog(_this__u8e3s4, item, writer) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  var tmp = KMutableProperty0();
  var tmp_0 = RowOrCol$_get_shown_$ref_m8lfse(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, RowOrCol$_set_shown_$ref_7290m6(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.baj(item);
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!it.jf9_1.i1()) {
      tmp_0 = true;
    } else {
      tmp_0 = !(it.hf9_1.i6k_1 == null);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !it.hf9_1.x6k_1.i1();
    }
    var tmp$ret$4 = tmp;
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  var priceChanges = lens(item, workItemChangeLog$lambda);
  view.dba(get_px(0));
  var logExpanded = Signal().fak(false);
  var tmp_1 = get_rawSession();
  var unread = lensUnread(tmp_1, (it) => {
    var tmp = it.nfv_1.hft(VOID, ($this$handleDelayUpdate, it) => $this$handleDelayUpdate.baj(item).jf9_1);
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_0();
    var tmp_0 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return tmp.sfw(it.mfv_1.mfu(tmp_0, VOID, VOID, ($this$handleCreditsDelayUpdate) => setOf($this$handleCreditsDelayUpdate.baj(item).hf9_1)));
  });
  leftExpandButtonWithUnread(view, logExpanded, unread, VOID, VOID, workItemChangeLog$lambda_0);
  var tmp_2 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(logExpanded));
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_3 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_4;
  var tmp_5 = null;
  if (!((tmp_5 == null ? null : new (Dimension())(tmp_5)) == null)) {
    tmp_4 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_4 = Companion_getInstance();
  }
  var tmp_6 = view_0.ibb(tmp_4, indented(view_0, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  var $this$sectionIndentCol = view_1;
  trackWeights(($this$trackWeights) => {
    space($this$sectionIndentCol, get_rem_0(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_0 = $this$sectionIndentCol;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(this_0.pc());
    var tmp0_elvis_lhs = this_0.cbb_1;
    var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
    this_0.ebb(p, view);
    view.xbm(false);
    view.jbb($this$trackWeights.mg6(view, 3.0), bodyBold(view, 'Work Item'));
    var tmp = $this$trackWeights.mg6(view, 1.0);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_0 = view_0.tb5_1;
    var tmp_1;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('ID') === 0) {
      tmp_1 = '\xA0';
    } else {
      tmp_1 = 'ID';
    }
    tmp_0.fbu(tmp_1);
    view_0.bbs(Align_Center_getInstance());
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_2 = $this$trackWeights.mg6(view, 1.0);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_3 = view_1.tb5_1;
    var tmp_4;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('Amount') === 0) {
      tmp_4 = '\xA0';
    } else {
      tmp_4 = 'Amount';
    }
    tmp_3.fbu(tmp_4);
    view_1.bbs(Align_Center_getInstance());
    view.fbb(p_1, view_1);
    view.jbb(tmp_2, view_1);
    var tmp_5 = $this$trackWeights.mg6(view, 1.0);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_6 = view_2.tb5_1;
    var tmp_7;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('Status') === 0) {
      tmp_7 = '\xA0';
    } else {
      tmp_7 = 'Status';
    }
    tmp_6.fbu(tmp_7);
    view_2.bbs(Align_Center_getInstance());
    view.fbb(p_2, view_2);
    view.jbb(tmp_5, view_2);
    var tmp_8 = $this$trackWeights.mg6(view, 1.0);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_9 = view_3.tb5_1;
    var tmp_10;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('Date') === 0) {
      tmp_10 = '\xA0';
    } else {
      tmp_10 = 'Date';
    }
    tmp_9.fbu(tmp_10);
    view_3.bbs(Align_Center_getInstance());
    view.fbb(p_3, view_3);
    view.jbb(tmp_8, view_3);
    var tmp_11 = $this$trackWeights.mg6(view, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Space())(view.pc());
    var tmp0_elvis_lhs_4 = view.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
    view.ebb(p_4, view_4);
    view.fbb(p_4, view_4);
    view.jbb(tmp_11, view_4);
    this_0.fbb(p, view);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = $this$sectionIndentCol;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(this_1.pc());
    var tmp0_elvis_lhs_5 = this_1.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? this_1 : tmp0_elvis_lhs_5;
    this_1.ebb(p_5, view_5);
    view_5.xbm(true);
    view_5.zb8(get_px(0));
    greySeparator(view_5);
    var tmp_12 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, VOID, get_changeLogRowHeight());
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (RowOrCol())(view_5.pc());
    var tmp0_elvis_lhs_6 = view_5.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
    view_5.ebb(p_6, view_6);
    view_6.xbm(false);
    var tmp_13 = $this$trackWeights.ng6(view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.ebb(p_7, view_7);
    view_7.xbm(false);
    view_7.zb8(get_AppDimensions().mg2_1);
    var tmp_14 = get_centered(view_7);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (TextView())(view_7.pc());
    var tmp0_elvis_lhs_8 = view_7.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
    view_7.ebb(p_8, view_8);
    view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_15 = KMutableProperty0();
    var tmp_16 = TextView$_get_content_$ref_4pzcwl(view_8);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb(view_8));
    reactiveScope(view_8, ($this$reactiveScope) => {
      var tmp$ret$42 = $this$reactiveScope.baj(item).lf9_1;
      this_2.set(tmp$ret$42);
      return Unit_instance;
    });
    view_7.fbb(p_8, view_8);
    view_7.jbb(tmp_14, view_8);
    var tmp_17 = get_centered(view_7);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (TextView())(view_7.pc());
    var tmp0_elvis_lhs_9 = view_7.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
    view_7.ebb(p_9, view_9);
    view_9.jba(view_9.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_18 = KMutableProperty0();
    var tmp_19 = TextView$_get_content_$ref_4pzcwl_0(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb_0(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      var tmp$ret$49 = !($this$reactiveScope.baj(item).hf9_1.i6k_1 == null) ? 'New' : 'Original';
      this_3.set(tmp$ret$49);
      return Unit_instance;
    });
    view_7.fbb(p_9, view_9);
    view_7.jbb(tmp_17, view_9);
    view_6.fbb(p_7, view_7);
    view_6.jbb(tmp_13, view_7);
    var tmp_20 = view_6.ibb($this$trackWeights.ng6(view_6), get_centered(view_6));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (TextView())(view_6.pc());
    var tmp0_elvis_lhs_10 = view_6.cbb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
    view_6.ebb(p_10, view_10);
    view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance()));
    view_10.bbs(Align_Center_getInstance());
    var tmp_21 = KMutableProperty0();
    var tmp_22 = TextView$_get_content_$ref_4pzcwl_1(view_10);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('content', 0, tmp_21, tmp_22, TextView$_set_content_$ref_pketfb_1(view_10));
    reactiveScope(view_10, ($this$reactiveScope) => {
      var info = $this$reactiveScope.baj(item).q94();
      var tmp$ret$60 = info == null ? '-' : info.a5b_1;
      this_4.set(tmp$ret$60);
      return Unit_instance;
    });
    view_6.fbb(p_10, view_10);
    view_6.jbb(tmp_20, view_10);
    var tmp_23 = view_6.ibb($this$trackWeights.ng6(view_6), get_centered(view_6));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (TextView())(view_6.pc());
    var tmp0_elvis_lhs_11 = view_6.cbb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_6 : tmp0_elvis_lhs_11;
    view_6.ebb(p_11, view_11);
    view_11.jba(view_11.ob6_1.ybe(BodySemantic_getInstance()));
    view_11.bbs(Align_Center_getInstance());
    var tmp_24 = KMutableProperty0();
    var tmp_25 = TextView$_get_content_$ref_4pzcwl_2(view_11);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_5 = getPropertyCallableRef('content', 0, tmp_24, tmp_25, TextView$_set_content_$ref_pketfb_2(view_11));
    reactiveScope(view_11, ($this$reactiveScope) => {
      var tmp$ret$67 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj(item).hf9_1.n6k_1);
      this_5.set(tmp$ret$67);
      return Unit_instance;
    });
    view_6.fbb(p_11, view_11);
    view_6.jbb(tmp_23, view_11);
    var tmp_26 = view_6.ibb($this$trackWeights.ng6(view_6), get_centered(view_6));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (TextView())(view_6.pc());
    var tmp0_elvis_lhs_12 = view_6.cbb_1;
    var p_12 = tmp0_elvis_lhs_12 == null ? view_6 : tmp0_elvis_lhs_12;
    view_6.ebb(p_12, view_12);
    view_12.jba(view_12.ob6_1.ybe(BodySemantic_getInstance()));
    view_12.bbs(Align_Center_getInstance());
    dynamicTheme(view_12, ($this$dynamicTheme) => !($this$dynamicTheme.baj(item).hf9_1.i6k_1 == null) ? ForegroundSemantic().agi(ChangeStatus_Accepted_getInstance().vh7_1) : null);
    var tmp_27 = KMutableProperty0();
    var tmp_28 = TextView$_get_content_$ref_4pzcwl_3(view_12);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_6 = getPropertyCallableRef('content', 0, tmp_27, tmp_28, TextView$_set_content_$ref_pketfb_3(view_12));
    reactiveScope(view_12, ($this$reactiveScope) => {
      var tmp$ret$74 = !($this$reactiveScope.baj(item).hf9_1.i6k_1 == null) ? 'Accepted' : '-';
      this_6.set(tmp$ret$74);
      return Unit_instance;
    });
    view_6.fbb(p_12, view_12);
    view_6.jbb(tmp_26, view_12);
    var tmp_29 = view_6.ibb($this$trackWeights.ng6(view_6), get_centered(view_6));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_13 = new (TextView())(view_6.pc());
    var tmp0_elvis_lhs_13 = view_6.cbb_1;
    var p_13 = tmp0_elvis_lhs_13 == null ? view_6 : tmp0_elvis_lhs_13;
    view_6.ebb(p_13, view_13);
    view_13.jba(view_13.ob6_1.ybe(BodySemantic_getInstance()));
    view_13.bbs(Align_Center_getInstance());
    var tmp_30 = KMutableProperty0();
    var tmp_31 = TextView$_get_content_$ref_4pzcwl_4(view_13);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_7 = getPropertyCallableRef('content', 0, tmp_30, tmp_31, TextView$_set_content_$ref_pketfb_4(view_13));
    reactiveScope(view_13, ($this$reactiveScope) => {
      var tmp$ret$81 = format($this$reactiveScope.baj(item).hf9_1.b6l_1, Formats_getInstance().j8z_1);
      this_7.set(tmp$ret$81);
      return Unit_instance;
    });
    view_6.fbb(p_13, view_13);
    view_6.jbb(tmp_29, view_13);
    var tmp_32 = $this$trackWeights.ng6(view_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_14 = new (Frame())(view_6.pc());
    var tmp0_elvis_lhs_14 = view_6.cbb_1;
    var p_14 = tmp0_elvis_lhs_14 == null ? view_6 : tmp0_elvis_lhs_14;
    view_6.ebb(p_14, view_14);
    var tmp_33 = get_centered(view_14);
    var tmp_34 = view_14.ibb(view_14.ibb(tmp_33, shownWhen(view_14, VOID, ($this$shownWhen) => !($this$shownWhen.baj(item).hf9_1.i6k_1 == null))), get_secondaryButton(view_14));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_15 = new (Button())(view_14.pc());
    var tmp0_elvis_lhs_15 = view_14.cbb_1;
    var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
    view_14.ebb(p_15, view_15);
    specCenteredText(view_15, 'View');
    onClick(view_15, 'View Change Details', VOID, workItemChangeLog$lambda$slambda_0(item));
    view_14.fbb(p_15, view_15);
    view_14.jbb(tmp_34, view_15);
    view_6.fbb(p_14, view_14);
    view_6.jbb(tmp_32, view_14);
    view_5.fbb(p_6, view_6);
    view_5.jbb(tmp_12, view_6);
    greySeparator(view_5);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_16 = new (RowOrCol())(view_5.pc());
    var tmp0_elvis_lhs_16 = view_5.cbb_1;
    var p_16 = tmp0_elvis_lhs_16 == null ? view_5 : tmp0_elvis_lhs_16;
    view_5.ebb(p_16, view_16);
    view_16.xbm(true);
    view_16.zb8(get_px(0));
    forEachUpdating(view_16, priceChanges, VOID, ($this$forEachUpdating, change) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachUpdating.pc());
      var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
      $this$forEachUpdating.ebb(p, view);
      view.xbm(true);
      view.zb8(get_px(0));
      var tmp = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_changeLogRowHeight());
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xbm(false);
      var tmp_0 = view_0.ibb($this$trackWeights.ng6(view_0), get_centered(view_0));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      view_1.xbm(false);
      view_1.zb8(get_AppDimensions().mg2_1);
      get_centered(view_1);
      unreadIconWhen(view_1, ($this$unreadIconWhen) => isUnread($this$unreadIconWhen.baj(change), $this$unreadIconWhen.baj(get_session()).efv_1));
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
      Companion_getInstance();
      var tmp_1 = get_centered(view_1);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view_1.pc());
      var tmp0_elvis_lhs_2 = view_1.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
      view_1.ebb(p_2, view_2);
      view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl_5(view_2);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_5(view_2));
      reactiveScope(view_2, ($this$reactiveScope) => {
        var tmp$ret$99 = $this$reactiveScope.baj(item).lf9_1;
        this_0.set(tmp$ret$99);
        return Unit_instance;
      });
      view_1.fbb(p_2, view_2);
      view_1.jbb(tmp_1, view_2);
      var tmp_4 = get_centered(view_1);
      // Inline function 'com.crowpay.views.theming.smallBody' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view_1.pc());
      var tmp0_elvis_lhs_3 = view_1.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
      view_1.ebb(p_3, view_3);
      view_3.jba(view_3.ob6_1.ybe(SmallBodySemantic_getInstance()));
      var tmp_5 = KMutableProperty0();
      var tmp_6 = TextView$_get_content_$ref_4pzcwl_6(view_3);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_6(view_3));
      reactiveScope(view_3, ($this$reactiveScope) => {
        var tmp$ret$106 = $this$reactiveScope.baj(change).f94();
        this_1.set(tmp$ret$106);
        return Unit_instance;
      });
      view_1.fbb(p_3, view_3);
      view_1.jbb(tmp_4, view_3);
      view_0.fbb(p_1, view_1);
      view_0.jbb(tmp_0, view_1);
      var tmp_7 = view_0.ibb($this$trackWeights.ng6(view_0), get_centered(view_0));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_4 = view_0.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
      view_0.ebb(p_4, view_4);
      view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_8 = KMutableProperty0();
      var tmp_9 = TextView$_get_content_$ref_4pzcwl_7(view_4);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_2 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_7(view_4));
      reactiveScope(view_4, ($this$reactiveScope) => {
        var tmp0_elvis_lhs = $this$reactiveScope.baj(change).g26();
        var tmp$ret$117 = tmp0_elvis_lhs == null ? '-' : tmp0_elvis_lhs;
        this_2.set(tmp$ret$117);
        return Unit_instance;
      });
      view_4.bbs(Align_Center_getInstance());
      view_0.fbb(p_4, view_4);
      view_0.jbb(tmp_7, view_4);
      var tmp_10 = $this$trackWeights.ng6(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Frame())(view_0.pc());
      var tmp0_elvis_lhs_5 = view_0.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
      view_0.ebb(p_5, view_5);
      var tmp_11 = get_centered(view_5);
      view_5.jbb(tmp_11, renderPriceChange(view_5, VOID, ($this$renderPriceChange) => new (MonetaryValue())($this$renderPriceChange.baj(change).a95())));
      view_0.fbb(p_5, view_5);
      view_0.jbb(tmp_10, view_5);
      var tmp_12 = view_0.ibb($this$trackWeights.ng6(view_0), get_centered(view_0));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_6 = view_0.cbb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
      view_0.ebb(p_6, view_6);
      view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
      view_6.bbs(Align_Center_getInstance());
      dynamicTheme(view_6, ($this$dynamicTheme) => {
        var tmp0_safe_receiver = workItemChangeLog$_anonymous_$status_rm1asd($this$dynamicTheme.baj(change));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = DisplayableStateSemantic().mgt(tmp0_safe_receiver);
        }
        return tmp;
      });
      var tmp_13 = KMutableProperty0();
      var tmp_14 = TextView$_get_content_$ref_4pzcwl_8(view_6);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_3 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_8(view_6));
      reactiveScope(view_6, ($this$reactiveScope) => {
        var tmp0_safe_receiver = workItemChangeLog$_anonymous_$status_rm1asd($this$reactiveScope.baj(change));
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g90();
        var tmp$ret$129 = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
        this_3.set(tmp$ret$129);
        return Unit_instance;
      });
      view_0.fbb(p_6, view_6);
      view_0.jbb(tmp_12, view_6);
      var tmp_15 = view_0.ibb($this$trackWeights.ng6(view_0), get_centered(view_0));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_7 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_7 = view_0.cbb_1;
      var p_7 = tmp0_elvis_lhs_7 == null ? view_0 : tmp0_elvis_lhs_7;
      view_0.ebb(p_7, view_7);
      view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance()));
      view_7.bbs(Align_Center_getInstance());
      var tmp_16 = KMutableProperty0();
      var tmp_17 = TextView$_get_content_$ref_4pzcwl_9(view_7);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_4 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb_9(view_7));
      reactiveScope(view_7, ($this$reactiveScope) => {
        var tmp$ret$136 = format($this$reactiveScope.baj(change).b95(), Formats_getInstance().j8z_1);
        this_4.set(tmp$ret$136);
        return Unit_instance;
      });
      view_0.fbb(p_7, view_7);
      view_0.jbb(tmp_15, view_7);
      var tmp_18 = $this$trackWeights.ng6(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_8 = new (Frame())(view_0.pc());
      var tmp0_elvis_lhs_8 = view_0.cbb_1;
      var p_8 = tmp0_elvis_lhs_8 == null ? view_0 : tmp0_elvis_lhs_8;
      view_0.ebb(p_8, view_8);
      var tmp_19 = view_8.ibb(get_centered(view_8), get_secondaryButton(view_8));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_9 = new (Button())(view_8.pc());
      var tmp0_elvis_lhs_9 = view_8.cbb_1;
      var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
      view_8.ebb(p_9, view_9);
      specCenteredText(view_9, 'View');
      onClick(view_9, 'View Change Details', VOID, workItemChangeLog$lambda$lambda$slambda_0(change, _this__u8e3s4, item));
      view_8.fbb(p_9, view_9);
      view_8.jbb(tmp_19, view_9);
      view_0.fbb(p_8, view_8);
      view_0.jbb(tmp_18, view_8);
      view.fbb(p_0, view_0);
      view.jbb(tmp, view_0);
      greySeparator(view);
      $this$forEachUpdating.fbb(p, view);
      return Unit_instance;
    });
    view_5.fbb(p_16, view_16);
    this_1.fbb(p_5, view_5);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_6, view_1);
  view.fbb(p_0, view_0);
  var tmp$ret$174 = view.jbb(tmp_3, view_0);
  view.jbb(tmp_2, tmp$ret$174);
  greySeparator(view, ($this$greySeparator) => {
    var tmp = KMutableProperty0();
    var tmp_0 = Separator$_get_shown_$ref_e9a0og($this$greySeparator);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Separator$_set_shown_$ref_f1kfq4($this$greySeparator));
    reactiveScope($this$greySeparator, ($this$reactiveScope) => {
      var tmp$ret$175 = !$this$reactiveScope.baj(logExpanded);
      this_0.set(tmp$ret$175);
      return Unit_instance;
    });
    return Unit_instance;
  });
  writer.fbb(p, view);
  return view;
}
function workItemActionBar(_this__u8e3s4, item, punchLists, project, lineItemCompletionMessages, pendingPayApp, pendingChange, role, liquidFunds, lens) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(get_AppDimensions().ig2_1);
  view.zb8(get_AppDimensions().ig2_1);
  var _destruct__k2r9zo = lineItemActions(view, item, punchLists, project, lineItemCompletionMessages, pendingPayApp, pendingChange, role, liquidFunds, lens);
  var primaryAction = _destruct__k2r9zo.cf();
  var secondaryAction = _destruct__k2r9zo.df();
  view.hb7(false);
  shownDefaultFalse(view, ($this$shownDefaultFalse) => (!($this$shownDefaultFalse.baj(primaryAction) == null) || !($this$shownDefaultFalse.baj(secondaryAction) == null)) && $this$shownDefaultFalse.baj(item).e99() == null);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().hg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.zb8(get_AppDimensions().ig2_1);
  var tmp = get_expanding(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  applyReactiveActionFormatting(view_2, secondaryAction);
  view_0.fbb(p_2, view_2);
  if (lens.equals(ProjectLens_Contractor_getInstance())) {
    var canRequestComplete = remember(VOID, VOID, VOID, ($this$remember) => {
      var tmp0_safe_receiver = $this$remember.baj(primaryAction);
      return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wg0_1) === 'Request Sign-Off';
    });
    var tmp_0 = get_centered(view_0);
    view_0.jbb(view_0.ibb(tmp_0, shownWhen(view_0, false, ($this$shownWhen) => $this$shownWhen.baj(canRequestComplete) && $this$shownWhen.baj(pendingPayApp))), infoBubble(view_0, 'Unavailable \u2014 item is in a draw under review. Void or wait to enable sign-off.'));
    var tmp_1 = get_centered(view_0);
    view_0.jbb(view_0.ibb(tmp_1, shownWhen(view_0, false, ($this$shownWhen) => $this$shownWhen.baj(canRequestComplete) && $this$shownWhen.baj(pendingChange))), infoBubble(view_0, 'Unavailable \u2014 item is in a change request under review. Void or wait to enable sign-off.'));
    var tmp_2 = get_centered(view_0);
    view_0.jbb(view_0.ibb(tmp_2, shownWhen(view_0, false, ($this$shownWhen) => {
      var project_0 = $this$shownWhen.baj(project);
      var item_0 = $this$shownWhen.baj(item);
      return $this$shownWhen.baj(canRequestComplete) && !project_0.r97() && (get_increasedProjectPrice(item_0.hf9_1) || MonetaryValue__compareTo_impl_w7ul1r(item_0.hf9_1.o91(), $this$shownWhen.baj(liquidFunds).a5s_1) > 0);
    })), infoBubble(view_0, 'Unavailable \u2014 client has not yet deposited all required funds for accepted changes.'));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  applyReactiveActionFormatting(view_3, primaryAction);
  view_0.fbb(p_3, view_3);
  view.fbb(p_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function lineItemActions(_this__u8e3s4, item, punchLists, project, lineItemCompletionMessages, payAppPending, pendingChange, role, liquidFunds, lens) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  var unreadMessages = remember(VOID, VOID, VOID, ($this$remember) => isUnread_0($this$remember.baj(lineItemCompletionMessages), $this$remember.baj(get_session()).efv_1));
  var primaryAction = remember(VOID, VOID, VOID, ($this$remember) => {
    var project_0 = $this$remember.baj(project);
    var lineItem = $this$remember.baj(item);
    var isCustomer = !lens.equals(ProjectLens_Contractor_getInstance());
    var isContractor = lens.equals(ProjectLens_Contractor_getInstance());
    var tmp0_safe_receiver = $this$remember.baj(role);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = tmp0_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
    }
    var tmp1_elvis_lhs = tmp;
    var isManager = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    var notComplete = lineItem.kfy().d4(LineItemState_Complete_getInstance()) < 0;
    var started = !(lineItem.lfy() == null);
    var notOnHold = !lineItem.kfy().equals(LineItemState_OnHold_getInstance());
    var notInScopeSet = lineItem.e99() == null;
    var tmp2_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var permissions = new (CompletionFlowPermissions())(lineItem.hf9_1, isCustomer, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j8c_1, $this$remember.baj(lineItemCompletionMessages));
    var previousMessage = permissions.x8w();
    var tmp_0;
    if (isContractor && isManager && notComplete && !started && notInScopeSet && setOf_0([ProjectState_PendingStart_getInstance(), ProjectState_InProgress_getInstance()]).t1(project_0.w7b_1)) {
      tmp_0 = ButtonAction().dg1('Start Work', VOID, VOID, VOID, VOID, VOID, lineItemActions$lambda$slambda_0(lineItem, project_0, $this$remember));
    } else if (isCustomer && notComplete && notOnHold && notInScopeSet && !lineItem.kfy().equals(LineItemState_KeepWorking_getInstance()) && permissions.v8y()) {
      var tmp3_safe_receiver = permissions.q8y();
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : acceptActionName(tmp3_safe_receiver, permissions.o8x_1);
      var tmp_1 = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      tmp_0 = ButtonAction().dg1(tmp_1, VOID, VOID, VOID, VOID, VOID, lineItemActions$lambda$slambda_2(permissions, $this$remember, project_0, lineItem, lens));
    } else if (isContractor && isManager && notComplete && setOf_0([ProjectState_InProgress_getInstance(), ProjectState_PreSubstantialCompletion_getInstance()]).t1(project_0.w7b_1) && notInScopeSet && setOf_0([LineItemState_InProgress_getInstance(), LineItemState_KeepWorking_getInstance(), LineItemState_WorkingOnRemedy_getInstance()]).t1(lineItem.kfy())) {
      var tmp_2 = ($this$ButtonAction) => !$this$ButtonAction.baj(payAppPending) && !$this$ButtonAction.baj(pendingChange) && MonetaryValue__compareTo_impl_w7ul1r(lineItem.hf9_1.o91(), $this$ButtonAction.baj(liquidFunds).a5s_1) <= 0;
      tmp_0 = ButtonAction().dg1('Request Sign-Off', VOID, VOID, VOID, VOID, tmp_2, lineItemActions$lambda$slambda_4(punchLists, item, lineItemCompletionMessages));
    } else if (isComplete(lineItem.kfy()) && (isManager || isCustomer)) {
      var tmp_3 = Companion_instance_0;
      var tmp_4 = SecondaryButtonSemantic_getInstance();
      var tmp_5 = ($this$withUnread) => $this$withUnread.baj(unreadMessages);
      tmp_0 = tmp_3.eg1('View History', tmp_4, VOID, VOID, tmp_5, lineItemActions$lambda$slambda_6(_this__u8e3s4, lineItem, $this$remember, project, lens));
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  });
  var secondaryAction = remember(VOID, VOID, VOID, ($this$remember) => {
    var project_0 = $this$remember.baj(project);
    var lineItem = $this$remember.baj(item);
    var isClient = !lens.equals(ProjectLens_Contractor_getInstance());
    var tmp0_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = tmp1_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
    }
    var tmp2_elvis_lhs = tmp;
    var isManager = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
    var tmp_0 = !lens.equals(ProjectLens_Contractor_getInstance());
    var tmp3_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var permissions = new (CompletionFlowPermissions())(lineItem.hf9_1, tmp_0, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.j8c_1, $this$remember.baj(lineItemCompletionMessages));
    var tmp_1;
    if (lens.xgj() && permissions.c8y() || (lens.xgj() && !(permissions.n8w() == null)) || (!lens.xgj() && isManager && !(permissions.n8w() == null))) {
      var tmp_2;
      var tmp4_safe_receiver = permissions.x8w();
      var tmp_3 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.f8w();
      if (!(tmp_3 == null) ? isInterface(tmp_3, NeedsApproval()) : false) {
        tmp_2 = permissions.c8y() ? 'Review Request' : 'View Request';
      } else {
        var tmp_4;
        var tmp_5;
        if (permissions.c8y()) {
          var tmp5_safe_receiver = permissions.x8w();
          var tmp_6 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.f8w();
          tmp_5 = tmp_6 instanceof MoreInfo();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp_4 = 'Provide Info';
        } else {
          var tmp_7;
          if (isClient) {
            // Inline function 'kotlin.run' call
            tmp_7 = (permissions.c8y() && !(permissions.p8y() == null) && !equals(permissions.p8y(), permissions.q8y()));
          } else {
            tmp_7 = false;
          }
          if (tmp_7) {
            var history = permissions.o8x_1.j8x(ensureNotNull(permissions.o8y()).g6h_1);
            var prop = ensureNotNull(permissions.p8y());
            var tmp_8;
            if (prop instanceof Remedy()) {
              tmp_8 = 'Review ' + prop.a8z(history);
            } else {
              tmp_8 = acceptActionName(prop, history);
            }
            tmp_4 = tmp_8;
          } else {
            if (permissions.c8y()) {
              tmp_4 = 'Review Concern';
            } else {
              tmp_4 = 'View Concern';
            }
          }
        }
        tmp_2 = tmp_4;
      }
      var tmp7_name = tmp_2;
      var tmp8_theme = SecondaryButtonSemantic_getInstance();
      var tmp_9 = ($this$withActionIcon) => requiresAction(permissions);
      var tmp_10 = ($this$withActionIcon) => $this$withActionIcon.baj(unreadMessages);
      tmp_1 = Companion_instance_0.mg1(tmp7_name, tmp8_theme, VOID, VOID, tmp_9, tmp_10, lineItemActions$lambda$slambda_8(_this__u8e3s4, lineItem, project_0, lens));
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  });
  return new (Pair())(primaryAction, secondaryAction);
}
function lineItemBanners$findAction(_this__u8e3s4, action) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.z7t_1.equals(action)) {
      destination.v(element);
    }
  }
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    var iterator = destination.m1();
    if (!iterator.n1()) {
      tmp$ret$3 = null;
      break $l$block_0;
    }
    var maxElem = iterator.o1();
    if (!iterator.n1()) {
      tmp$ret$3 = maxElem;
      break $l$block_0;
    }
    var tmp0_elvis_lhs = maxElem.x7t_1;
    var maxValue = tmp0_elvis_lhs == null ? Companion_getInstance_1().e1m_1 : tmp0_elvis_lhs;
    do {
      var e = iterator.o1();
      var tmp0_elvis_lhs_0 = e.x7t_1;
      var v = tmp0_elvis_lhs_0 == null ? Companion_getInstance_1().e1m_1 : tmp0_elvis_lhs_0;
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.n1());
    tmp$ret$3 = maxElem;
  }
  return tmp$ret$3;
}
function workItemChangeLog$_anonymous_$status_rm1asd(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Credit()) {
    tmp = null;
  } else {
    if (_this__u8e3s4 instanceof ItemChange()) {
      tmp = get_status(_this__u8e3s4);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function renderLineItemDetails$lambda(it) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  return it.hf9_1;
}
function renderLineItemDetails$lambda_0(it) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  return it.mf9_1;
}
function lineItemBanners$lambda(it) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  return it.w7b_1.equals(ProjectState_Locked_getInstance());
}
function workItemNotes$lambda($this$leftExpandButtonWithUnread) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  body($this$leftExpandButtonWithUnread, 'Notes');
  return Unit_instance;
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.wb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.hhw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var it = tmp;
  get_dialogStack().xgd(CreateOrEditNote().gh0(it.jfy(), it.kf9_1, null));
  return Unit_instance;
}
var workItemNotes$slambdaClass;
function workItemNotes$slambda() {
  if (workItemNotes$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.hhw_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    workItemNotes$slambdaClass = $;
  }
  return workItemNotes$slambdaClass;
}
function workItemNotes$slambda_0($item) {
  var i = new (workItemNotes$slambda())($item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function workItemChangeLog$lambda(it) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = plus(it.jf9_1, it.hf9_1.x6k_1);
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = workItemChangeLog$lambda$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
  return sortedWith(this_0, tmp$ret$0);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ihw_1 = function_0;
      }
      wi(a, b) {
        return this.ihw_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ihw_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function workItemChangeLog$lambda$lambda(a, b) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.b95();
  var tmp$ret$1 = b.b95();
  return compareValues(tmp, tmp$ret$1);
}
function workItemChangeLog$lambda_0($this$leftExpandButtonWithUnread) {
  _init_properties_lineItemDetails_kt__1mr0y1();
  body($this$leftExpandButtonWithUnread, 'Log');
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = JumpTo_getInstance().ng3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jhw_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.zg4(tmp$ret$0.kf9_1);
  return Unit_instance;
}
var workItemChangeLog$lambda$slambdaClass;
function workItemChangeLog$lambda$slambda() {
  if (workItemChangeLog$lambda$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.jhw_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    workItemChangeLog$lambda$slambdaClass = $;
  }
  return workItemChangeLog$lambda$slambdaClass;
}
function workItemChangeLog$lambda$slambda_0($item) {
  var i = new (workItemChangeLog$lambda$slambda())($item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.khw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  if (c instanceof Credit()) {
    var tmp0_safe_receiver = c.c5r_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = $this.lhw_1.tgm();
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      // Inline function 'kotlin.collections.find' call
      var tmp0 = tmp_1;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.kf9_1.equals(tmp0_safe_receiver)) {
            tmp$ret$3 = element;
            break $l$block;
          }
        }
        tmp$ret$3 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$3;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        throw NotFound().nfx(getKClass(LineItem()), null);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var line = tmp_2;
      var tmp_3 = Companion_instance_1;
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $this.lhw_1.jfy();
      var tmp_4 = await_0(this_2, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var tmp$ret$5 = tmp_4;
      var tmp_5 = tmp_3.cgu(line, tmp$ret$5, $this.lhw_1.rgj(), VOID, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      tmp_0 = tmp_5;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_6;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = c.d5r_1;
      var tmp_7;
      if (tmp2_safe_receiver == null) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_3 = $this.lhw_1.ggt();
        var tmp_8 = await_0(this_3, $completion);
        if (tmp_8 === get_COROUTINE_SUSPENDED())
          tmp_8 = yield tmp_8;
        // Inline function 'kotlin.collections.find' call
        var tmp0_0 = tmp_8;
        var tmp$ret$10;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.d63_1.equals(tmp2_safe_receiver)) {
              tmp$ret$10 = element_0;
              break $l$block_0;
            }
          }
          tmp$ret$10 = null;
        }
        var tmp0_elvis_lhs_0 = tmp$ret$10;
        var tmp_9;
        if (tmp0_elvis_lhs_0 == null) {
          throw NotFound().nfx(getKClass(Incident()), null);
        } else {
          tmp_9 = tmp0_elvis_lhs_0;
        }
        var incident = tmp_9;
        var tmp_10 = Companion_instance_2;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_4 = $this.lhw_1.jfy();
        var tmp_11 = await_0(this_4, $completion);
        if (tmp_11 === get_COROUTINE_SUSPENDED())
          tmp_11 = yield tmp_11;
        var tmp_12 = tmp_11;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_5 = $this.lhw_1.cgt();
        var tmp_13 = await_0(this_5, $completion);
        if (tmp_13 === get_COROUTINE_SUSPENDED())
          tmp_13 = yield tmp_13;
        var tmp$ret$13 = tmp_13;
        var tmp_14 = tmp_10.vgq(tmp_12, incident, tmp$ret$13, $this.lhw_1.rgj(), $completion);
        if (tmp_14 === get_COROUTINE_SUSPENDED())
          tmp_14 = yield tmp_14;
        tmp_7 = tmp_14;
      }
      tmp_6 = tmp_7;
    } else {
      tmp_6 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_6;
    var tmp_15;
    if (tmp3_elvis_lhs == null) {
      var tmp_16;
      if (c.e5r_1 == null) {
        tmp_16 = c;
      } else {
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_6 = $this.lhw_1.jfy();
        var tmp_17 = await_0(this_6, $completion);
        if (tmp_17 === get_COROUTINE_SUSPENDED())
          tmp_17 = yield tmp_17;
        // Inline function 'kotlin.collections.find' call
        var tmp0_1 = tmp_17.z7b_1;
        var tmp$ret$18;
        $l$block_1: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_1 = tmp0_1.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            if (element_1.e5r_1 == c.e5r_1) {
              tmp$ret$18 = element_1;
              break $l$block_1;
            }
          }
          tmp$ret$18 = null;
        }
        tmp_16 = tmp$ret$18;
      }
      var tmp4_safe_receiver = tmp_16;
      var tmp_18;
      if (tmp4_safe_receiver == null) {
        tmp_18 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_7 = $this.lhw_1.wgk();
        var tmp_19 = await_0(this_7, $completion);
        if (tmp_19 === get_COROUTINE_SUSPENDED())
          tmp_19 = yield tmp_19;
        var tmp_20 = tmp_19;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_8 = $this.lhw_1.fgl();
        var tmp_21 = await_0(this_8, $completion);
        if (tmp_21 === get_COROUTINE_SUSPENDED())
          tmp_21 = yield tmp_21;
        var tmp_22 = tmp_21;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_9 = get_session();
        var tmp_23 = await_0(this_9, $completion);
        if (tmp_23 === get_COROUTINE_SUSPENDED())
          tmp_23 = yield tmp_23;
        var tmp_24 = tmp_23.efv_1;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_10 = $this.lhw_1.jfy();
        var tmp_25 = await_0(this_10, $completion);
        if (tmp_25 === get_COROUTINE_SUSPENDED())
          tmp_25 = yield tmp_25;
        var tmp_26 = tmp_25;
        var tmp_27;
        if (c.e5r_1 == null) {
          // Inline function 'com.lightningkite.reactive.context.invoke' call
          var this_11 = $this.mhw_1;
          var tmp_28 = await_0(this_11, $completion);
          if (tmp_28 === get_COROUTINE_SUSPENDED())
            tmp_28 = yield tmp_28;
          tmp_27 = tmp_28.hf9_1;
        } else {
          tmp_27 = null;
        }
        tmp_18 = new (CreditDetails())(tmp4_safe_receiver, tmp_20, tmp_22, tmp_24, tmp_26, tmp_27);
      }
      tmp_15 = tmp_18;
    } else {
      tmp_15 = tmp3_elvis_lhs;
    }
    var page = tmp_15;
    if (page == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      get_dialogStack().xgd(page);
    }
  } else {
    if (c instanceof ItemChange()) {
      JumpTo_getInstance().ng3_1.zg4(c.x6a_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return Unit_instance;
}
var workItemChangeLog$lambda$lambda$slambdaClass;
function workItemChangeLog$lambda$lambda$slambda() {
  if (workItemChangeLog$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($change, $this_workItemChangeLog, $item) {
        this.khw_1 = $change;
        this.lhw_1 = $this_workItemChangeLog;
        this.mhw_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    workItemChangeLog$lambda$lambda$slambdaClass = $;
  }
  return workItemChangeLog$lambda$lambda$slambdaClass;
}
function workItemChangeLog$lambda$lambda$slambda_0($change, $this_workItemChangeLog, $item) {
  var i = new (workItemChangeLog$lambda$lambda$slambda())($change, $this_workItemChangeLog, $item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Separator$_get_shown_$ref_e9a0og(p0) {
  return () => p0.wb8();
}
function Separator$_set_shown_$ref_f1kfq4(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.nhw_1.baj(get_session()).mfv_1.kft($this.ohw_1.kf9_1);
    // Inline function 'com.lightningkite.lightningdb.modification' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
    var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$0);
    var tmp_1 = get_started(it);
    // Inline function 'com.lightningkite.now' call
    var tmp$ret$2 = get_default(Companion_instance_3).d1m();
    this_0.e44(tmp_1, tmp$ret$2);
    var tmp$ret$6 = this_0.o1r();
    var tmp_2 = tmp.len(tmp$ret$6, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function invoke$confirmation($this_remember, lineItem, header, confirmationText, message) {
  var tmp = PrimaryButtonSemantic_getInstance();
  return new (GenericConfirmationDialog())(header, message, VOID, confirmationText, VOID, tmp, VOID, VOID, VOID, VOID, lineItemActions$lambda$slambda$confirmation$slambda_0($this_remember, lineItem));
}
function invoke$confirmation$default($this_remember, lineItem, header, confirmationText, message, $super) {
  message = message === VOID ? '' : message;
  return invoke$confirmation($this_remember, lineItem, header, confirmationText, message);
}
var lineItemActions$lambda$slambda$confirmation$slambdaClass;
function lineItemActions$lambda$slambda$confirmation$slambda() {
  if (lineItemActions$lambda$slambda$confirmation$slambdaClass === VOID) {
    class $ {
      constructor($this_remember, $lineItem) {
        this.nhw_1 = $this_remember;
        this.ohw_1 = $lineItem;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambda$confirmation$slambdaClass = $;
  }
  return lineItemActions$lambda$slambda$confirmation$slambdaClass;
}
function lineItemActions$lambda$slambda$confirmation$slambda_0($this_remember, $lineItem) {
  var i = new (lineItemActions$lambda$slambda$confirmation$slambda())($this_remember, $lineItem);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var lineItemActions$lambda$slambdaClass;
function lineItemActions$lambda$slambda() {
  if (lineItemActions$lambda$slambdaClass === VOID) {
    class $ {
      constructor($lineItem, $project, $this_remember) {
        this.phw_1 = $lineItem;
        this.qhw_1 = $project;
        this.rhw_1 = $this_remember;
      }
      wah($this$ButtonAction, $completion) {
        get_dialogStack().xgd(MonetaryValue__compareTo_impl_w7ul1r(this.phw_1.hf9_1.o91(), this.qhw_1.s97()) > 0 ? invoke$confirmation(this.rhw_1, this.phw_1, 'Start Work Item Without Funds?', 'Start Work Item', 'The client has accepted changes in scope without depositing additional funds. You may want to delay starting work until funds have been successfully transferred into escrow. If you choose to start working before funds are in escrow, you will not be able to request sign-off until the remaining funds have been deposited.') : this.qhw_1.g7c_1 == null ? invoke$confirmation$default(this.rhw_1, this.phw_1, 'Start Work Item & Project?', 'Start Work Item & Project') : invoke$confirmation$default(this.rhw_1, this.phw_1, 'Start Work Item?', 'Start Work Item'));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambdaClass = $;
  }
  return lineItemActions$lambda$slambdaClass;
}
function lineItemActions$lambda$slambda_0($lineItem, $project, $this_remember) {
  var i = new (lineItemActions$lambda$slambda())($lineItem, $project, $this_remember);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, it, $completion) {
  if (!it)
    return Unit_instance;
  var session = $this.shw_1.baj(get_session());
  var tmp = session.tfw().ffg_1.ofm(new (LineItemCompletionMessage())(VOID, $this.thw_1.x7a_1, $this.uhw_1.kf9_1, session.efv_1, $this.vhw_1.xgj(), serializable(new (Accept())($this.whw_1, session.ufw())), ''), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var lineItemActions$lambda$slambda$slambdaClass;
function lineItemActions$lambda$slambda$slambda() {
  if (lineItemActions$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_remember, $project, $lineItem, $lens, $proposal) {
        this.shw_1 = $this_remember;
        this.thw_1 = $project;
        this.uhw_1 = $lineItem;
        this.vhw_1 = $lens;
        this.whw_1 = $proposal;
      }
      cgk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambda$slambdaClass = $;
  }
  return lineItemActions$lambda$slambda$slambdaClass;
}
function lineItemActions$lambda$slambda$slambda_0($this_remember, $project, $lineItem, $lens, $proposal) {
  var i = new (lineItemActions$lambda$slambda$slambda())($this_remember, $project, $lineItem, $lens, $proposal);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
var lineItemActions$lambda$slambdaClass_0;
function lineItemActions$lambda$slambda_1() {
  if (lineItemActions$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($permissions, $this_remember, $project, $lineItem, $lens) {
        this.xhw_1 = $permissions;
        this.yhw_1 = $this_remember;
        this.zhw_1 = $project;
        this.ahx_1 = $lineItem;
        this.bhx_1 = $lens;
      }
      wah($this$ButtonAction, $completion) {
        var tmp0_elvis_lhs = this.xhw_1.p8y();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var proposal = tmp;
        var text = acceptConfirmationText(proposal, this.xhw_1);
        var tmp_0 = get_dialogStack();
        var tmp_1;
        if (proposal instanceof RequestComplete()) {
          tmp_1 = 'SIGN-OFF REVIEW';
        } else {
          tmp_1 = null;
        }
        var tmp_2 = tmp_1;
        tmp_0.xgd(new (GenericConfirmationDialog())(text.tw_1, text.uw_1, VOID, text.vw_1, VOID, VOID, VOID, VOID, VOID, tmp_2, lineItemActions$lambda$slambda$slambda_0(this.yhw_1, this.zhw_1, this.ahx_1, this.bhx_1, proposal)));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambdaClass_0 = $;
  }
  return lineItemActions$lambda$slambdaClass_0;
}
function lineItemActions$lambda$slambda_2($permissions, $this_remember, $project, $lineItem, $lens) {
  var i = new (lineItemActions$lambda$slambda_1())($permissions, $this_remember, $project, $lineItem, $lens);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $this$ButtonAction, $completion) {
  var tmp = awaitSuspending($this.chx_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0 = tmp;
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_0;
    if (isInterface(tmp0, Collection())) {
      tmp_0 = tmp0.i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.r7w_1 && element.s7w_1 == null) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  if (tmp$ret$0) {
    get_dialogStack().xgd(GenericDialog().zgy('You still have required punch list items pending. You cannot request review until all required punch list items are complete.'));
  } else {
    var tmp_1 = get_dialogStack();
    var tmp_2 = awaitSuspending($this.dhx_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = listOf(tmp_2);
    var tmp_4 = awaitSuspending($this.ehx_1, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_1.xgd(WorkItemRequestSignOffDialog(tmp_3, tmp_4));
  }
  return Unit_instance;
}
var lineItemActions$lambda$slambdaClass_1;
function lineItemActions$lambda$slambda_3() {
  if (lineItemActions$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($punchLists, $item, $lineItemCompletionMessages) {
        this.chx_1 = $punchLists;
        this.dhx_1 = $item;
        this.ehx_1 = $lineItemCompletionMessages;
      }
      wah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambdaClass_1 = $;
  }
  return lineItemActions$lambda$slambdaClass_1;
}
function lineItemActions$lambda$slambda_4($punchLists, $item, $lineItemCompletionMessages) {
  var i = new (lineItemActions$lambda$slambda_3())($punchLists, $item, $lineItemCompletionMessages);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $this$withUnread, $completion) {
  var tmp = Companion_instance_1.cgu($this.ghx_1, $this.hhx_1.baj($this.ihx_1), $this.jhx_1, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = tmp;
  set_value(this_0.hgv_1, true);
  navigateOrDialog($this.fhx_1, this_0);
  return Unit_instance;
}
var lineItemActions$lambda$slambdaClass_2;
function lineItemActions$lambda$slambda_5() {
  if (lineItemActions$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_lineItemActions, $lineItem, $this_remember, $project, $lens) {
        this.fhx_1 = $this_lineItemActions;
        this.ghx_1 = $lineItem;
        this.hhx_1 = $this_remember;
        this.ihx_1 = $project;
        this.jhx_1 = $lens;
      }
      wah($this$withUnread, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$withUnread), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambdaClass_2 = $;
  }
  return lineItemActions$lambda$slambdaClass_2;
}
function lineItemActions$lambda$slambda_6($this_lineItemActions, $lineItem, $this_remember, $project, $lens) {
  var i = new (lineItemActions$lambda$slambda_5())($this_lineItemActions, $lineItem, $this_remember, $project, $lens);
  var l = ($this$withUnread, $completion) => i.wah($this$withUnread, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $this$withActionIcon, $completion) {
  if (get_viewIsNarrow($this.khx_1)) {
    var tmp = get_mainPageNavigator($this.khx_1);
    var tmp_0 = Companion_instance_1.cgu($this.lhx_1, $this.mhx_1, $this.nhx_1, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp.dbw(tmp_0);
  } else {
    var tmp_1 = get_dialogStack();
    var tmp_2 = Companion_instance_1.cgu($this.lhx_1, $this.mhx_1, $this.nhx_1, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_1.xgd(tmp_2);
  }
  return Unit_instance;
}
var lineItemActions$lambda$slambdaClass_3;
function lineItemActions$lambda$slambda_7() {
  if (lineItemActions$lambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($this_lineItemActions, $lineItem, $project, $lens) {
        this.khx_1 = $this_lineItemActions;
        this.lhx_1 = $lineItem;
        this.mhx_1 = $project;
        this.nhx_1 = $lens;
      }
      wah($this$withActionIcon, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$withActionIcon), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    lineItemActions$lambda$slambdaClass_3 = $;
  }
  return lineItemActions$lambda$slambdaClass_3;
}
function lineItemActions$lambda$slambda_8($this_lineItemActions, $lineItem, $project, $lens) {
  var i = new (lineItemActions$lambda$slambda_7())($this_lineItemActions, $lineItem, $project, $lens);
  var l = ($this$withActionIcon, $completion) => i.wah($this$withActionIcon, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_lineItemDetails_kt_b60i2z;
function _init_properties_lineItemDetails_kt__1mr0y1() {
  if (!properties_initialized_lineItemDetails_kt_b60i2z) {
    properties_initialized_lineItemDetails_kt_b60i2z = true;
    changeLogRowHeight = get_rem_0(3);
  }
}
//region block: exports
export {
  lineItemActions as lineItemActions16vo8euhaqrwf,
  lineItemBanners as lineItemBanners14ilhfznw9y75,
  renderLineItemDetails as renderLineItemDetails23mbed1k3mdfc,
};
//endregion

//# sourceMappingURL=lineItemDetails.mjs.map
